export const config = {
  title: "Navarre",
  company_logo: "navarre.png",
  logo_placements: ["Left Chest", "Front Center"],
  show_image_preview: true,
  embroideries: {
    hat: [
      "Navarre",
      "Navarre Cadillac",
      "Navarre Chevrolet",
      "Navarre GMC",
      "Navarre Honda",
      "Navarre Hyundai",
      "Navarre Jeep Ram",
      "Navarre Nissan",
      "Navarre Premium Select",         
    ],
    mens: [
      "Navarre",
      "Navarre Cadillac",
      "Navarre Chevrolet",
      "Navarre GMC",
      "Navarre Honda",
      "Navarre Hyundai",
      "Navarre Jeep Ram",
      "Navarre Nissan",
      "Navarre Premium Select",
    ],
    womens: [
      "Navarre",
      "Navarre Cadillac",
      "Navarre Chevrolet",
      "Navarre GMC",
      "Navarre Honda",
      "Navarre Hyundai",
      "Navarre Jeep Ram",
      "Navarre Nissan",
      "Navarre Premium Select",
    ],
    accessory: [],
    customs: [],
    office: [],
    service: [],
    sales: [],
    detail: [],
    bodyshop: [],
    parts: [],
  },
  email_recipients: [
    "lbudbill@gpcorp.com",
    "lbudbell@comcast.net",
    "rgreenberg@gpcorp.com",
  ],
  stores: [
    {
      name: "Navarre Chevrolet",
      address: "1300 East College St, Lake Charles, LA 70607",
      code: "NAVCLA",
    },
    {
      name: "Navarre Chevrolet of Sulphur",
      address: "1620 Beglis Parkway, Sulphur, LA 70663",
      code: "NAVCSU",
    },
    {
      name: "Navarre Hyundai of Lake Charles",
      address: "1310 East College St, Lake Charles, LA 70607",
      code: "NAVHLK",
    },
    {
      name: "Navarre Buick GMC",
      address: "3690 Gerstner Memorial Drive, Lake Charles, LA 70607",
      code: "NAVBLA",
    },
    {
      name: "Navarre Honda",
      address: "1320 East College St, Lake Charles, LA 70607",
      code: "NAVHLA",
    },
    {
      name: "Navarre Cadillac",
      address: "1300 East College St, Lake Charles, LA 70607",
      code: "NAVCLK",
    },
    {
      name: "Navarre Chevrolet Inc.",
      address: "4441 Jackson St EXT, Alexandria, LA 71303",
      code: "VAUMAX",
    },
    {
      name: "Navarre Jeep Ram Dodge Chrysler",
      address: "299 S Cities Service Hwy, Sulphur, LA 70663",
      code: "NAVCSL",
    },
    {
      name: "Navarre Nissan",
      address: "1700 Siebarth Dr, Lake Charles, LA 70615",
      code: "NAVNLA",
    },
  ],
  bypass_codes: ["NAVARR"],
  server_hostname: "https://mxfj3q6m01.execute-api.us-east-1.amazonaws.com",
  account_reps: [{ name: "Richard Greenberg", phone: "678-287-1635" }],
  route_prefix: "/navarre",
  paypal_not_supported: true,
  password: "NavarrE",
};
